var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('StarRating',{attrs:{"star-size":16,"active-color":_vm.muted ? _vm.GREY : _vm.YELLOW,"max-rating":10,"padding":7,"read-only":_vm.readOnly,"rating":_vm.value,"show-rating":_vm.showText},on:{"rating-selected":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }